/**
 * Authentication types and enums
 * These represent internal application state and configuration types
 */

import type { UserSessionDTO, UserDTO } from './dtos';
import type { AuthTenantDTO } from '../manage/dtos';

// Enums
export enum UserRole {
  SYSTEM_ADMIN = 'SYSTEM_ADMIN',
  UNIVERSITY_ADMIN = 'UNIVERSITY_ADMIN',
  FACULTY_ADMIN = 'FACULTY_ADMIN',
  PROFESSOR = 'PROFESSOR',
  COURSE_REPRESENTATIVE = 'COURSE_REPRESENTATIVE',
}

export enum AUTH_STATES {
  LOGIN = 'login',
  RESET_PASSWORD = 'reset_password',
  RESET_PASSWORD_REQUESTED = 'reset_password_requested',
  RESET_PASSWORD_CONFIRM = 'confirm_reset',
  REGISTER = 'register',
  MFA_CHALLENGE = 'mfa_challenge',
}

// User attribute constants
export const USER_ATTRIBUTES = {
  TENANT: 'custom:tenantId',
  IS_TENANT_ADMIN: 'custom:is_tenant_admin',
  IS_SUPER_ADMIN: 'custom:is_super_admin',
} as const;

// Auth state interfaces for store management
export interface AuthState {
  user: UserDTO | null;
  accessToken: string | null;
  idToken: string | null;
  refreshToken: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
}

export interface MultiTenantAuthState extends AuthState {
  currentTenant: AuthTenantDTO | null;
  accessibleTenants: AuthTenantDTO[];
  userSession: UserSessionDTO | null;
  isSwitchingTenant: boolean;
  tenantSwitchError: string | null;
  lastTenantRefresh: string | null;
}
